import { Flex } from '@frontend/legacy-components';

import BaseErrorFallback from './BaseErrorFallback';

const FullSizeErrorFallback = () => (
  <Flex height="100%" justifyContent="center" alignItems="center">
    <BaseErrorFallback />
  </Flex>
);

export default FullSizeErrorFallback;
